// extracted by mini-css-extract-plugin
export default {"DefaultSelect":"DefaultSelect_DefaultSelect__VLEaj"};